// This is a manifest file that'll be compiled into application.js, which will include all the files
// listed below.
//
// Any JavaScript/Coffee file within this directory, lib/assets/javascripts, vendor/assets/javascripts,
// or any plugin's vendor/assets/javascripts directory can be referenced here using a relative path.
//
// It's not advisable to add code directly here, but if you do, it'll appear at the bottom of the
// compiled file. JavaScript code in this file should be added after the last require_* statement.
//
// Read Sprockets README (https://github.com/rails/sprockets#sprockets-directives) for details
// about supported directives.

import metypeHome from '../metype-home';
import '../../stylesheet/home.css';
import '../../stylesheet/doorkeeper.css';
require('es6-promise').polyfill();

function startApp() {
  __webpack_public_path__ = (window.cdn + "/quintype-metype/assets/") ||  __webpack_public_path__

  global.metypeHome = metypeHome;

  (metypeHome.__initial_callbacks || []).forEach(function(args) {
    metypeHome.apply(metypeHome, args);
  });
}

startApp();

if(process.env.NODE_ENV == "development" && module.hot) {
  module.hot.accept("../metype-home", () => {
    console.log("Hot Reload!");
    startApp();
  })
}



// WEBPACK FOOTER //
// ./app/javascript/packs/home.js